const styles = (theme) => ({
  iconButtonRoot: {
    padding: 0
  },
  icon: { color: '#6D6E71' }
});

export default styles;
